/**
 * `scrollLeft` center utility
 *
 * This utility sets the `scrollLeft` position to center.
 */
const initScrollLeftCenter = () => {
  const doPosition = (element: Element) =>
    (element.scrollLeft = Math.round(
      element.scrollWidth / 2 - element.clientWidth / 2
    ));

  document.querySelectorAll(".js-scroll-left-center").forEach(doPosition);
};

export default initScrollLeftCenter();
